/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ProductStockUnitDto = {
  /**
   * Warehouse inventory product id
   */
  id: number;
  /**
   * Unique piece code (e.g. 910/99)
   */
  productCodeUnique: string;
  /**
   * Location id
   */
  locationId: number | null;
  /**
   * Branch display name
   */
  locationName: string;
  /**
   * Availability status
   */
  availabilityStatus: ProductStockUnitDto.availabilityStatus;
};
export namespace ProductStockUnitDto {
  /**
   * Availability status
   */
  export enum availabilityStatus {
    AVAILABLE = 'AVAILABLE',
    RESERVED = 'RESERVED',
  }
}
